$(function() {

    $('.label-group').each(function(i, labelGroup) {
        var $labelGroup = $(labelGroup);
        $labelGroup.on('click', 'label', function() {
            $labelGroup.find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');
        });
    });

    $('#qf1').submit(function(e) {
        e.preventDefault();
        var uri = $(this).find('input[name="qf1-type"]:checked').val();
        var dateArrival = document.querySelector('#qf1-datepicker1').value;
        var dateDeparture = document.querySelector('#qf1-datepicker2').value;
        var adults = 1;

        if (uri == 'sejour-et-produit-package') {
            var href = `${base_url}/fr/${uri}?cbDate=1&rbl=calendar&dd=${encodeURI(dateDeparture)}&df=${encodeURI(dateArrival)}`;
            window.location.href = href
        } else {
            dw.accommodationQuickFind(
                'sttropez', {
                    dateFrom: new Date(dateArrival),
                    dateTo: new Date(dateDeparture),
                    occupancy1: {
                        units: 1,
                        adults: adults,
                        children: 0
                    }
                },
                function() {
                    window.location.href = `${base_url}/fr/${uri}`
                })
        }
        return false;
    });

    $('#qf5').submit(function(e) {
        e.preventDefault();

        var dateArrival = document.querySelector('#quickFinder5-datepicker1').value;
        var dateDeparture = document.querySelector('#quickFinder5-datepicker2').value;
        var adults = document.querySelector('#quickFinder5_adults').value;
        adults = (adults !== '') ? adults : '1';
        dw.accommodationQuickFind(
            'sttropez', {
                dateFrom: new Date(dateArrival),
                dateTo: new Date(dateDeparture),
                occupancy1: {
                    units: 1,
                    adults: adults,
                    children: 0
                }
            },
            function() {
                window.location.href = base_url + "/fr/hebergements"
            })

        return false;
    });

});